import { MapProps } from '@vis.gl/react-google-maps';

export const defaultMapConfig: MapProps = {
  defaultZoom: 0,
  defaultCenter: {
    lat: 48.43919727139413,
    lng: 9.743455501696545,
  },
  minZoom: 3,
  mapTypeControl: false,
  streetViewControl: false,
  gestureHandling: 'greedy',
  scrollwheel: true,
};

export const GEOFENCE_MINIMUM_RADIUS = 300;
export const GEOFENCE_DEFAULT_RADIUS = 300;
